__turbopack_context__.v({
  "stepShell": "styles-module-scss-module__QuSxXG__stepShell",
  "stepShell__body": "styles-module-scss-module__QuSxXG__stepShell__body",
  "stepShell__inlineActions": "styles-module-scss-module__QuSxXG__stepShell__inlineActions",
  "stepShell__note": "styles-module-scss-module__QuSxXG__stepShell__note",
  "stepShell__slide": "styles-module-scss-module__QuSxXG__stepShell__slide",
  "stepShell__subtitle": "styles-module-scss-module__QuSxXG__stepShell__subtitle",
  "stepShell__title": "styles-module-scss-module__QuSxXG__stepShell__title",
});
